import React from "react";
import { isFunction } from "lodash";
import { extractAnimatedHeightProps } from "./util";
import { AnimatedHeightWithRef } from "./animatedHeightWithRef";

const AnimatedHeightDefaultProps  = { 
  element: "div"
};

export const _AnimatedHeight = (props) => {
  const {render, children, ...otherProps} = extractAnimatedHeightProps(props);
  if (isFunction(render)) {
    return (
      <AnimatedHeightWithRef {...otherProps}>
        {(renderProp) => render(renderProp)}
      </AnimatedHeightWithRef>
    );
  }

  return (
    <AnimatedHeightWithRef {...otherProps}>
      {(renderProps) => (
        <div {...renderProps}>{children}</div>
      )}
    </AnimatedHeightWithRef>
  );
};

export const AnimatedHeight = (props) => (<_AnimatedHeight {...AnimatedHeightDefaultProps} {...props} />);

// AnimatedHeight.defaultProps = {
//   element: "div"
// };